import { gql } from '@apollo/client'

export const EXECUTED_PAYMENTS_BY_CONTRACT_ID = gql`
  query excecutedPaymentsByContractId($id: HashedId!) {
    excecutedPaymentsByContractId(id: $id) {
      executedPayments {
        id
        amount
        paymentDate
        type
        referenceYear
        currency
      }
    }
  }
`

export const TARGET_BONUS_BY_CONTRACT_ID = gql`
  query targetBonusByContractId($id: HashedId!) {
    targetBonusByContractId(id: $id) {
      targetBonusHistory {
        id
        amount
        note
        isTentative
        currency
        fromDate
        toDate
        contractId
      }
    }
  }
`

export const SALARY_BY_CONTRACT_ID = gql`
  query salaryByContractId($id: HashedId!) {
    salaryByContractId(id: $id) {
      salaryHistory {
        id
        amount
        note
        isTentative
        currency
        fromDate
        toDate
        contractId
        isFulltime
        percentageOfWorktime
      }
    }
  }
`

export const CONTRACT_EMPLOYEE_LEVELS_BY_CONTRACT_ID = gql`
  query contractEmployeeLevelsByContractId($id: HashedId!) {
    contractEmployeeLevelsByContractId(id: $id) {
      contractEmployeeLevelHistory {
        id
        level
        note
        isTentative
        fromDate
        toDate
      }
    }
  }
`

export const NATIONAL_CONTRACT_EMPLOYEE_LEVELS_BY_CONTRACT_ID = gql`
  query nationalContractEmployeeLevelsByContractId($id: HashedId!) {
    nationalContractEmployeeLevelsByContractId(id: $id) {
      nationalContractEmployeeLevelHistory {
        id
        level
        type
        note
        isTentative
        fromDate
        toDate
      }
    }
  }
`

export const EXECUTED_PAYMENTS_BY_EMPLOYEE_ID = gql`
  query excecutedPaymentsByEmployeeId($employeeId: HashedId!, $employeeResigned: Boolean = false) {
    excecutedPaymentsByEmployeeId(employeeId: $employeeId, employeeResigned: $employeeResigned) {
      executedPayments {
        id
        amount
        paymentDate
        type
        referenceYear
        currency
      }
    }
  }
`

export const TARGET_BONUS_BY_EMPLOYEE_ID = gql`
  query targetBonusByEmployeeId($employeeId: HashedId!, $employeeResigned: Boolean = false) {
    targetBonusByEmployeeId(employeeId: $employeeId, employeeResigned: $employeeResigned) {
      targetBonusHistory {
        id
        amount
        note
        isTentative
        currency
        fromDate
        toDate
        contractId
      }
    }
  }
`

export const SALARY_BY_EMPLOYEE_ID = gql`
  query salaryByEmployeeId($employeeId: HashedId!, $employeeResigned: Boolean = false) {
    salaryByEmployeeId(employeeId: $employeeId, employeeResigned: $employeeResigned) {
      salaryHistory {
        id
        amount
        note
        isTentative
        currency
        fromDate
        toDate
        contractId
        isFulltime
        percentageOfWorktime
      }
    }
  }
`

export const CONTRACT_EMPLOYEE_LEVELS_BY_EMPLOYEE_ID = gql`
  query contractEmployeeLevelsByEmployeeId($employeeId: HashedId!, $employeeResigned: Boolean = false) {
    contractEmployeeLevelsByEmployeeId(employeeId: $employeeId, employeeResigned: $employeeResigned) {
      contractEmployeeLevelHistory {
        id
        level
        note
        isTentative
        fromDate
        toDate
      }
    }
  }
`

export const NATIONAL_CONTRACT_EMPLOYEE_LEVELS_BY_EMPLOYEE_ID = gql`
  query nationalContractEmployeeLevelsByEmployeeId($employeeId: HashedId!, $employeeResigned: Boolean = false) {
    nationalContractEmployeeLevelsByEmployeeId(employeeId: $employeeId, employeeResigned: $employeeResigned) {
      nationalContractEmployeeLevelHistory {
        id
        level
        type
        note
        isTentative
        fromDate
        toDate
      }
    }
  }
`

export const CONTRACT_GOVERNMENT_JOB_TITLE_HISTORY_BY_EMPLOYEE_ID = gql`
  query contractGovernmentJobTitleHistoryByEmployeeId($employeeId: HashedId!, $employeeResigned: Boolean = false) {
    contractGovernmentJobTitleHistoryByEmployeeId(employeeId: $employeeId, employeeResigned: $employeeResigned) {
      id
      governmentJobTitle {
        id
        hiringOffice {
          id
          code
        }
        department
        title
        level
      }
      fromDate
      toDate
      note
    }
  }
`
